import { Currency } from '../../../../model'
import { StakeState } from './useStake'

export function getButtonState(state: StakeState, integralToken: Currency) {
  switch (state) {
    case StakeState.WALLET_NOT_CONNECTED:
      return { text: 'Connect wallet', error: false, disabled: true }
    case StakeState.INSUFFICIENT_BALANCE:
      return { text: `Insufficient ${integralToken.symbol} balance`, error: false, disabled: true }
    case StakeState.MISSING_INPUT:
    case StakeState.NEED_APPROVAL:
      return { text: 'Confirm stake', error: false, disabled: true }
    default:
      return { text: 'Confirm stake', error: false, disabled: false }
  }
}
